import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME } from 'Common/FormEnum';
import CreateEditKitchenPrepWorksheetComponent from '../../components/createEditKitchenPrepWorksheet/CreateEditKitchenPrepWorksheet';

class CreateEditKitchenPrepWorksheetContainer extends Component {
  render() {
    return <CreateEditKitchenPrepWorksheetComponent {...this.props} />;
  }
}

export const CreateEditKitchenPrepWorksheetForm = reduxForm({
  form: CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(CreateEditKitchenPrepWorksheetContainer);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/containers/createEditKitchenPrepWorksheet/CreateEditKitchenPrepWorksheetContainer.js